//型号管理
export const sequenceStatus = [
  {id: 0, msg: "否"},
  {id: 1, msg: "是"},
];
export const checksumStatus = [
  {id: 0, msg: "否"},
  {id: 1, msg: "是"},
];
//MAC池
export const macSuffixType = [
  {id: 0, msg: "未使用", backgroundColor: "#fff"},
  {id: 1, msg: "LAN", backgroundColor: "#409EFF"},
  {id: 2, msg: "WAN", backgroundColor: "#F1635F"},
  {id: 3, msg: "2.4G", backgroundColor: "#FEBA47"},
  {id: 4, msg: "5.8G", backgroundColor: "#D99A2E"},
  {id: 5, msg: "6G", backgroundColor: "#B47B1A"},
];
//MAC订单
export const orderStatus = [
  {id: 0, msg: "正在生成", color: "color-primary"},
  {id: 1, msg: "生成成功", color: "color-success"},
  {id: 2, msg: "生成失败", color: "color-danger"},
  {id: 3, msg: "终止生成", color: "color-disable"},
  {id: 4, msg: "正在删除"},
  {id: 5, msg: "删除失败", color: "color-warning"},
];
//授权服务
export const serverStatus = [
  {id: 0, msg: "禁用", color: "color-danger"},
  {id: 1, msg: "启用", color: "color-success"},
];
export const serverType = [
  {id: "bill", msg: "计费"},
  {id: "audit", msg: "审计"},
  {id: "ai", msg: "盟友"},
];
export const serverFrom = [
  {id: "0", msg: "平台手动"},
  {id: "1", msg: "在线订单", color: "color-success"},
];
export const poolStatus = [
  {id: "0", msg: "待导入"},
  {id: "1", msg: "正在导入", color: "color-warning"},
  {id: "2", msg: "导入成功", color: "color-success"},
  {id: "3", msg: "导入失败", color: "color-danger"},
  {id: "4", msg: "正在删除", color: "color-warning"},
  {id: "5", msg: "删除失败", color: "color-danger"},
];
//应用账号
export const appStatus = [
  {id: 0, msg: "禁用", color: "color-danger"},
  {id: 1, msg: "启用", color: "color-success"},
];

export const commonChanger = [
  {id: 0, msg: "关闭"},
  {id: 1, msg: "开启"},
];

export const platformType = [
  "MT7620",
  "MT7621",
  "MT7628",
  "MT7981",
  "MT7986",
  "MT7988",
  "RT-OPWRT",
  "RTL",
  "QCA",
  "QCA-93",
  "QCA-OP",
  "CM",
  "CT",
  "X86",
  "X86-64",
  "MV-A8K",
  "MV-A38X",
  "MV-CN9130",
];

export const billOrderType = [
  {id: "0", msg: "线上支付"},
];
export const billMethod = [
  {id: "wxpay", msg: "微信"},
  {id: "alipay", msg: "支付宝"},
];
export const billStatus = [
  {id: 0, msg: "未支付", color: "color-warning"},
  {id: 1, msg: "已支付", color: "color-success"},
  {id: 2, msg: "已取消", color: "color-danger"},
  {id: 3, msg: "订单过期", color: "color-disable"},
  {id: 4, msg: "订单已退款", color: "color-danger"},
  {id: 5, msg: "订单已锁定", color: "color-disable"},
  {id: 6, msg: "支付失败", color: "color-disable"},
  {id: 7, msg: "订单已关闭", color: "color-disable"},
];

export const billUserAction = [
  {id: "new", msg: "新购买"},
  {id: "renew", msg: "续费"},
];

export const loginStatus = [
  {id: false, msg: "失败", color: "color-danger"},
  {id: true, msg: "成功", color: "color-success"},
];

export const commonStatusBoole = [
  {id: false, msg: "已禁用", color: "color-disable"},
  {id: true, msg: "已启用", color: "color-success"},
]

export const licensePriceUnit = [
  {id: 'hour', msg: "1小时"},
  {id: 'day', msg: "1天"},
  {id: 'month', msg: "1个月"},
  {id: 'year', msg: "1年"},
  {id: 'count', msg: "1个"},
];

export const licenseIsRecommend = [
  {id: false, msg: "否"},
  {id: true, msg: "是"},
];

export const licenseType = [
  {id: 'ai', msg: "盟友"},
  {id: 'bill', msg: "计费"},
  {id: 'audit', msg: "审计"},
];

export const oemType = [
  { id: "1", msg: "WAYOS" },
  { id: "2", msg: "SECNET" },
  { id: "3", msg: "RQ" },
  { id: "4", msg: "DLINK" },
  { id: "5", msg: "BEST" },
  { id: "6", msg: "ICES" },
  { id: "7", msg: "QS" },
  { id: "8", msg: "1TMT" },
  { id: "9", msg: "DEFAIN" },
  { id: "10", msg: "WAYOS_BAR" },
  { id: "11", msg: "HANBO" },
  { id: "12", msg: "BLINK" },
  { id: "13", msg: "SHENSI" },
  { id: "14", msg: "UNION" },
  { id: "15", msg: "LBB" },
  { id: "16", msg: "PAISEN" },
  { id: "17", msg: "NETSHARK" },
  { id: "18", msg: "OEM_WITOWN" },
  { id: "19", msg: "DWP" },
  { id: "20", msg: "SAITIAN" },
  { id: "21", msg: "DLINK_CROSS" },
  { id: "22", msg: "DLINK_AP" },
  { id: "23", msg: "OEM_FIH" },
  { id: "24", msg: "SHUNWANG" },
  { id: "25", msg: "OEM_WAT" },
  { id: "26", msg: "SHENGTIAN" },
  { id: "27", msg: "TOC" },
  { id: "28", msg: "IPROS" },
  { id: "29", msg: "ADITONG" },
  { id: "30", msg: "SHENGMAYA" },
  { id: "31", msg: "XINNUO" },
  { id: "32", msg: "MAIPU" },
  { id: "33", msg: "SEGIT" },
  { id: "34", msg: "ADITONG_AP" },
  { id: "35", msg: "WEIKE" },
  { id: "36", msg: "WANSHANG" },
  { id: "37", msg: "RUIJIE" },
  { id: "38", msg: "RAISECOM" },
  { id: "39", msg: "EMEE" },
  { id: "40", msg: "ZTE" },
  { id: "41", msg: "VTION" },
  { id: "42", msg: "VTION_AP" },
  { id: "43", msg: "YUNLUTONG" },
  { id: "44", msg: "YIXIANG" },
  { id: "45", msg: "YUNCHUANG" },
  { id: "46", msg: "DATANG" },
  { id: "47", msg: "DATANG_AP" },
  { id: "48", msg: "WAYOS_VER4" },
  { id: "49", msg: "DISHU" },
  { id: "50", msg: "WIS" },
  { id: "51", msg: "WDJ" },
  { id: "52", msg: "PEOPLE" },
  { id: "53", msg: "YILUTONG" },
  { id: "54", msg: "YUNLUYOU" },
  { id: "55", msg: "YISHANG" },
  { id: "56", msg: "JINLANG" },
  { id: "57", msg: "YICHUANG" },
  { id: "58", msg: "ZHONGJIAN" },
  { id: "59", msg: "WENWANG" },
  { id: "60", msg: "HANBO_OEM" },
  { id: "61", msg: "XD" },
  { id: "62", msg: "FENGHUO" },
  { id: "63", msg: "XINWANGJIAN" },
  { id: "64", msg: "PUTIAN" },
  { id: "65", msg: "JIANXIN" },
  { id: "66", msg: "ZXWT" },
  { id: "67", msg: "YIHAO" },
  { id: "68", msg: "HZW" },
  { id: "69", msg: "JIANHU" },
  { id: "70", msg: "SAIYANG" },
  { id: "71", msg: "JSON" },
  { id: "72", msg: "YONGHENG" },
  { id: "73", msg: "GUANGTONG" },
  { id: "74", msg: "MILE" },
  { id: "75", msg: "WANGQI" },
  { id: "76", msg: "YSQ" },
  { id: "77", msg: "YIHE" },
  { id: "78", msg: "HUIKE" },
  { id: "79", msg: "HEXICOM" },
  { id: "80", msg: "KUAIJIE" },
  { id: "81", msg: "XUNZHOU" },
  { id: "82", msg: "KEKEJL" },
  { id: "83", msg: "AUSTIN" },
  { id: "84", msg: "SSYK" },
  { id: "85", msg: "RUIYITONG" },
  { id: "86", msg: "MIAOLINK" },
  { id: "87", msg: "ZHIJIAHUI" },
  { id: "88", msg: "LIANGXIN" },
  { id: "89", msg: "COMMON" },
  { id: "90", msg: "YIWANG" },
  { id: "91", msg: "YUQI" },
  { id: "92", msg: "TXGLINK" },
  { id: "93", msg: "CHUANYIN" },
  { id: "94", msg: "LEMON" },
  { id: "95", msg: "HONEYWELL" },
  { id: "96", msg: "AINOPOL" },
  { id: "97", msg: "BIDU" },
  { id: "98", msg: "COOL_GEEKS" },
  { id: "99", msg: "DAHUA" },
  { id: "100", msg: "NUOXC" },
  { id: "101", msg: "WUGEE" },
  { id: "102", msg: "INTELBRAS" },
  { id: "103", msg: "XIANGYU" },
  { id: "104", msg: "KINGNET" },
  { id: "105", msg: "HOMYCLOUD" },
  { id: "106", msg: "CHANGWANG" },
  { id: "107", msg: "BDCOM" },
  { id: "108", msg: "TGNET" },
  { id: "109", msg: "SKYLAB" },
  { id: "110", msg: "LANGCHAO" },
  { id: "111", msg: "ZHONGKE" },
  { id: "112", msg: "ORG" },
  { id: "113", msg: "GENATA" },
  { id: "114", msg: "JINSHUN" },
  { id: "115", msg: "JINSHUN_TC" },
  { id: "116", msg: "JINSHUN_WD" },
  { id: "117", msg: "DEEPLEARN" },
  { id: "118", msg: "JINSHUN_NW" },
  { id: "119", msg: "JINSHUN_ITT" },
  { id: "120", msg: "JINSHUN_NIVEO" },
  { id: "121", msg: "HONGRUI" },
  { id: "122", msg: "GUANFU" },
  { id: "123", msg: "TXTS" },
  { id: "124", msg: "JINSHUN_TW" }
]